import { ModalDialog } from '../components/ui/ModalDialog'

export function DiscardDraftDialog({ name, pending, onClose, onConfirm }: {
  name: string
  pending: boolean
  onClose: () => void
  onConfirm: () => void
}) {
  return <ModalDialog title="Discard draft?" description="Discarding this draft removes your unpublished changes. The current published AI Use is not affected." onClose={onClose}>
    <p className="muted">{name ? `Draft: ${name}` : 'This private working draft will be removed.'}</p>
    <div className="simple-strategy-dialog-actions">
      <button className="button secondary" type="button" onClick={onClose} disabled={pending}>Keep draft</button>
      <button className="button danger-outline" type="button" onClick={onConfirm} disabled={pending}>{pending ? 'Discarding…' : 'Discard draft'}</button>
    </div>
  </ModalDialog>
}
